<template>
  <CModal :show="show" :closeOnBackdrop="false" :centered="true" size="lg">
    <template #header>
      <h5 class="modal-title">{{ title }}</h5>
    </template>
    <div v-if="!loading">
      <form @submit.prevent="onSubmit">
        <div class="form-group">
          <label>{{ $t("models.mpc.price_mode") }}</label>
          <select class="form-control" v-model="form.price_mode">
            <option
              v-for="method in priceModes"
              :key="method.id"
              :value="method.id"
            >
              {{ method.label }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ $t("models.mpc.recharge") }}</label>
          <CInput
            v-model.number="form.recharge"
            type="number"
            step="1"
            min="0"
            max="100"
            append="%"
          />
        </div>
      </form>

      <CAlert v-if="validationError" color="danger" :show.sync="showAlert">
        {{ validationError }}
      </CAlert>
    </div>
    <div
      v-else
      class="d-flex justify-content-center align-items-center"
      style="height: 200px"
    >
      <CSpinner color="primary" />
    </div>

    <template #footer>
      <CButton color="primary" variant="outline" @click.prevent="closeModal">
        {{ $t("common.editor.cancel") }}
      </CButton>
      <vue-ladda
        :loading="loading"
        data-style="zoom-in"
        button-class="btn btn-primary px-4"
        @click.prevent="onSubmit"
      >
        {{ $t("common.editor.confirm") }}
      </vue-ladda>
    </template>
  </CModal>
</template>

<script>
import { apiPatch } from "../../../helpers/apiHelper";

export default {
  name: "SettingsProducerModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editId: {
      type: [Number, String],
      default: null,
    },
    values: {
      type: Object,
      default: () => ({}),
    },
    priceModes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loading: false,
      validationError: null,
      showAlert: false,
      form: {
        price_mode: 0,
        recharge: 0,
      },
    };
  },

  watch: {
    show: {
      handler(isShown) {
        if (isShown) {
          if (this.values && Object.keys(this.values).length > 0) {
            this.populateForm(this.values);
          } else {
            this.resetForm();
          }
        }
      },
      immediate: false,
    },
    values: {
      handler(newValues) {
        if (newValues && Object.keys(newValues).length > 0) {
          this.populateForm(newValues);
        }
      },
      immediate: true,
    },
  },

  methods: {
    populateForm(data) {
      this.form.price_mode = data.price_mode || 0;
      this.form.recharge = data.recharge || 0;
      this.loading = false;
    },

    async onSubmit() {
      this.showAlert = false;

      let requestParams = this.values || {};
      requestParams.price_mode = this.form.price_mode;
      requestParams.recharge = this.form.recharge;

      // check user permissions before submitting
      const perm = this.$store.state.connections.current.permissions.role_pp;
      if (perm !== 2) {
        this.validationError = this.$t(
          "models.market_plan.addForm.validation.permissions"
        );
        this.showAlert = true;
        return;
      }

      let response;
      if (this.editId) {
        response = await apiPatch(
          "role_marketproducer_connections",
          this.editId,
          requestParams,
          [this.$store.state.role.id]
        );
      }

      if (response && response.status === 200) {
        this.$emit("submitted");
        this.closeModal();
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error saving data",
          color: "danger",
          autohide: true,
        });
      }
    },

    closeModal() {
      this.$emit("update:show", false);
      this.validationError = null;
      this.showAlert = false;
    },

    resetForm() {
      this.form = {
        price_mode: 0,
        recharge: 0,
      };
      this.validationError = null;
      this.showAlert = false;
    },
  },
};
</script>
